import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'CreateUserButton' })(() => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 'var(--ebl-s2)',
  },
  button: {
    minWidth: '120px',
  },
}));
